import React, { useState } from "react";
import MyModal from "../Common/MyModal";
import { Button, Form } from "react-bootstrap";
import {
  useCreateUpdateEventMutation,
  useGetEventSolutionsQuery,
  useUpdateNoSolutionEventMutation,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import { AbsoluteLoadingIndicator } from "../Common/FullScreenLoadingIndicator";
import { useDispatch } from "react-redux";
import { reportingProxyAPI } from "../store/slices/reportingSlice";

export default function EventCreateAnUpdateModal({ eventData, eventSolution }) {
  const [createUpdate] = useCreateUpdateEventMutation();
  const [message, setMessage] = useState("");
  const [field, setField] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  return (
    <MyModal
      label=" Create a customer Update"
      buttonClassName="bg-colored-reverse px-3 rounded-pill btn-sm border-0 fw-bold text-white text-nowrap p-1"
      heading="Create a customer Update"
    >
      <div className="bg-white p-3 rounded-2 my-3">
        <AbsoluteLoadingIndicator loading={loading} />

        <div className="fw-bold my-2">Do you want to create a customer update?</div>
        <Form.Group className="mb-3" controlId="createUpdateTextarea">
          <Form.Label>Update Details</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Form.Group>
      </div>
      <div className="d-flex justify-content-end">
        <Button
          className="bg-colored-reverse px-3 rounded-pill  border-0 btn-sm fw-bold mt-3"
          onClick={async () => {
            setLoading(true);
            await createUpdate({
              SolutionClientUuid: eventSolution.Uuid,
              ID: eventData.Reference,
              Message: message,
            })
              .then((res) => {
                if ("data" in res) {
                  toast.success("Customer update created successfully");
                  dispatch(
                    reportingProxyAPI.util.invalidateTags(["ReportingEntries"])
                  );
                }
              })
              .finally(() => {
                setMessage("");
                setTimeout(() => {
                  setLoading(false);
                }, 500);
              });
          }}
          disabled={loading || !message}
        >
          <div className="text-white"> Create a customer update</div>
        </Button>
      </div>
    </MyModal>
  );
}
